"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _pclnDesignSystem = require("pcln-design-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Card = _styledComponents["default"].div.withConfig({
  componentId: "sc-1e3ajtc-0"
})(["position:relative;display:flex;flex-direction:column;background-color:white;border-radius:", "px;& > .card-section:first-child{border:1px solid ", ";border-top-left-radius:", "px;border-top-right-radius:", "px;}& > .card-section:not(:first-child){border-bottom:1px solid ", ";border-left:1px solid ", ";border-right:1px solid ", ";}& > .card-section:last-child{border-bottom-left-radius:", "px;border-bottom-right-radius:", "px;}", ""], (0, _themeGet.themeGet)('radii.2'), (0, _pclnDesignSystem.getPaletteColor)('border.base'), (0, _themeGet.themeGet)('radii.2'), (0, _themeGet.themeGet)('radii.2'), (0, _pclnDesignSystem.getPaletteColor)('border.base'), (0, _pclnDesignSystem.getPaletteColor)('border.base'), (0, _pclnDesignSystem.getPaletteColor)('border.base'), (0, _themeGet.themeGet)('radii.2'), (0, _themeGet.themeGet)('radii.2'), function (props) {
  return !props.hasDividers && "\n        & > .card-section:first-child {\n            border: none;\n        }\n    \n        & > .card-section:not(:first-child) {\n            border: none;\n        }\n        \n        & > .card-section:last-child {\n            border: none;\n        }\n    ";
});

function ProperCard(_ref) {
  var className = _ref.className,
      hasDividers = _ref.hasDividers,
      children = _ref.children,
      cypressName = _ref.cypressName;
  return _react["default"].createElement(Card, {
    className: className,
    hasDividers: hasDividers,
    "data-cy": cypressName || 'proper-card'
  }, children);
}

ProperCard.displayName = 'ProperCard';
ProperCard.propTypes = {
  className: _propTypes["default"].string,
  hasDividers: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  cypressName: _propTypes["default"].string
};
ProperCard.defaultProps = {
  className: '',
  hasDividers: true
};

var _default = (0, _react.memo)(ProperCard);

exports["default"] = _default;